import styled from "styled-components"
import { supportedOhioCounties, supportedKentuckyCounties } from "./Coordinates"

const SupportedCounties = () =>{

    return (
        <SupportedCountiesContainer>
            <SupportedHeaderTextContainer>
              <SupportedCountiesHeaderText>Currently Servicing:</SupportedCountiesHeaderText>
            </SupportedHeaderTextContainer>

            <SupportedCountiesListContainer>
                <OhioCountiesContainer>
                  <OhioCountiesHeader>In Ohio:</OhioCountiesHeader>
                  
                  <OhioCountiesListContainer>
                      {supportedOhioCounties.map((item, idx) =>(
                      <OhioCountiesList key={idx}>{item.name} County</OhioCountiesList>  
                      ))}  
                  </OhioCountiesListContainer>
                </OhioCountiesContainer>

                <KentuckyCountiesContainer>
                  <KentuckyCountiesHeader>In Kentucky</KentuckyCountiesHeader>
                  
                  <KentuckyCountiesListContainer>
                      {supportedKentuckyCounties.map((item, idx) =>(
                      <KentuckyCountiesList key={idx}>{item.name} County</KentuckyCountiesList>  
                      ))}
                  </KentuckyCountiesListContainer>
                </KentuckyCountiesContainer>
            </SupportedCountiesListContainer>
      </SupportedCountiesContainer>
    )
}

const SupportedCountiesContainer = styled.div`
  width: 100%;
  height: 100%;
`

const SupportedCountiesListContainer = styled.div`
  width: 100%;  
  height: 90%;
  display: flex;
`

const SupportedHeaderTextContainer = styled.div`
  height: 10%;
  text-align: center;
`

const SupportedCountiesHeaderText = styled.text`
  color: white;
  font-size: 35px;
  font-weight: 400;
  @media(max-width: 1300px){
    font-size: 25px;
  }
`

const OhioCountiesContainer = styled.div`
  text-align: center;
  width: 50%;
`

const OhioCountiesHeader = styled.text`
  color: white;
  font-size: 45px;
  font-weight: 200;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  @media(max-width: 1300px){
    font-size: 25px;
  }
`

const OhioCountiesListContainer = styled.div`
  width: 75%;
  margin: auto;
  @media(max-width: 1300px){
    width: 50%;
  }
`

const OhioCountiesList = styled.li`
  list-style-type: none;
  font-size: 28px;
  color: white;
  @media(max-width: 1300px){
    font-size: 14px;
  }
`

const KentuckyCountiesContainer = styled.div`
  text-align: center;
  width: 50%;
`

const KentuckyCountiesHeader = styled.text`
  color: white;
  font-size: 45px;
  font-weight: 200;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  @media(max-width: 1300px){
    font-size: 25px;
  }
`

const KentuckyCountiesListContainer = styled.div`
  width: 75%;
  margin: auto;
`

const KentuckyCountiesList = styled.li`
  list-style-type: none;
  font-size: 28px;
  color: white;
  @media(max-width: 1300px){
    font-size: 14px;
  }
`

export default SupportedCounties
